import { mediaUrl, type BoardNode } from './boardModel';

/** TIFF originals stay downloadable; uploaded attachments already have JPEG previews. */
export function boardImageUrl(node: Pick<BoardNode, 'src' | 'attachmentId'>): string | undefined {
  const original = mediaUrl(node.src);
  if (!original || !node.attachmentId) return original;
  try {
    const url = new URL(original, window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/uploads/') || !/\.tiff?$/i.test(url.pathname)) return original;
    const slash = url.pathname.lastIndexOf('/');
    url.pathname = `${url.pathname.slice(0, slash)}/_thumbs/${url.pathname.slice(slash + 1)}.jpg`;
    return `${url.pathname}${url.search}`;
  } catch { return original; }
}
